export default "__VITE_PUBLIC_ASSET__d01f4c73__"